import React, { useState } from 'react'
import { Table, Button, Divider, Popconfirm, Row, Col, Tag ,Tooltip } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import BrandCoverForm from './BrandCoverForm'
import { ACTION } from '../../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import {
  createBrandCover,
  updateBrandCover,
  fetchBrandCoverList,
  deleteBrandCover
} from '../../../modules/brandCover'
import PreviewImage from '../../../components/PreviewImage'

const BrandCover = ({ brandId }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)
  const [action, setAction] = useState(ACTION.CREATE)

  const { brandCoverList ,isLoading } = useSelector(
    (state) => ({
      brandCoverList: state.brandCover.brandCoverList,
      isLoading:state.brandCover.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandCoverList(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'No',
      key: 'No',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.image)
          }}>
          View
        </a>
      )
    },
    {
      title: 'หัวข้อ',
      key: 'title',
      dataIndex: 'title'
    },
    {
      title: 'URL',
      key: 'url',
      dataIndex: 'url',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      render: (name, row) => (
        <Tooltip title={name}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {name}
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, ACTION.UPDATE, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onOk(data) {
    if (action === ACTION.CREATE) {
      await dispatch(createBrandCover(data))
    } else {
      await dispatch(updateBrandCover(data))
    }

    await setVisible(false)
    await dispatch(fetchBrandCoverList(brandId))
  }

  async function onDelete(id) {
    await dispatch(deleteBrandCover(id))
    await dispatch(fetchBrandCoverList(brandId))
  }

  const onClick = (e, type, record) => {
    e.preventDefault()
    setVisible(true)
    setAction(type)

    if (type === ACTION.UPDATE) {
      setFormState(record)
    }
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Cover List</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e, ACTION.CREATE)}>
              Add Cover
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        title={HeaderTable}
        bordered
        loading={isLoading}
        dataSource={brandCoverList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <BrandCoverForm
        action={action}
        formState={formState}
        visible={visible}
        onOk={onOk}
        brandId={brandId}
        onCancel={onCloseModal}
      />
    </div>
  )
}

export default BrandCover
